import roleReducers from './reducer';
import * as roleActions from './reducer';

export { roleActions };

export default roleReducers;
